<template>
    <div v-if="section" class="container-fluid col-12 articles-container">
        <h2 class="pl-2">{{ section.descricao }}</h2>
        <div class="col-12 content d-flex flex-wrap p-0 mt-4">
            <div v-if="section.articles.length == 0"
                class="col-12 mt-md-5 d-flex justify-content-center">
                <p>Não há artigos nesta seção!</p>
            </div>
            <div v-else class="section-wrapper col-12 col-md-4 p-0">
                <ul class="list-container mt-0">
                    <li class="section-content"
                        @click="ChangeArticle(article)"
                        v-for="article in section.articles"
                        :key="article.id">
                        <router-link class="article-li"
                            :to="{ name: 'Article', params: {
                                article_slug: article.slug
                            }}">
                            {{ article.titulo }}
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-md-8 article-wrapper">
                <Article
                    v-if="article"
                    v-model="article">
                </Article>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Article from './../../articles/components/Article'

export default {
    name: "Section",
    components: {
        Article
    },
    props:  {
        section_slug: {
            type:       String,
            default:    ''
        },
        props_search: {
            type:       String,
            default:    ''
        }
    },
    data () {
        return {
            article: null,
            section: null,
            search: ''
        }
    },
    computed: {
        ...mapGetters('system', [
            'categories', 'sections'
        ]),
        article_slug() {
            let slug = null

            const match = this.$route.fullPath.match(/#.+$/)

            if(match?.length) {
                slug = match[0]?.replace('#', '')
            }

            return slug
        }
    },
    watch: {
        props_search: {
            handler(val)
            {
                this.search = val
            }
        },
        filtered_articles: {
            handler(val)
            {
                if(!this.is_slug)
                {
                    this.url_slug = val[0].slug
                }
            }
        },
        $route: {
            async handler(val, old_val) {
                if(this.section?.descricao) {
                    document.title = "IM | FAQ - " + this.section.descricao
                } else {
                    document.title = "IM | FAQ"
                }

                if(val.params.section_slug != old_val.params.section_slug) {
                    await this.GetArticles()
                }
            }
        }
    },
    methods: {
        ...mapActions('system', [
            'StartLoading', 'FinishLoading'
        ]),
        async GetArticles() {
            const vm = this

            vm.StartLoading()

            return await window.api.call('post', '/get-faq-items', {
                section_slug: vm.section_slug,
            })
                .then(({data}) => {
                    if(data.response) {
                        if(data.section) {
                            vm.section = data.section
    
                            vm.articles = vm.section.articles
    
                            if(vm.section?.descricao) {
                                document.title = "IM | FAQ - " + vm.section.descricao
                            } else {
                                document.title = "IM | FAQ"
                            }
    
                            if(vm.article_slug) {
                                vm.article = vm.articles.find(a => a.slug == vm.article_slug)
                            }
                        }

                    }
                })
                .finally(() => {
                    vm.FinishLoading()
                })
        },
        async ChangeArticle(article) {
            this.article = article
        },
    },
    beforeMount() {
        this.GetArticles()
    },
}
</script>

<style>

@media (min-width: 1500px) {
    .articles-container {
        max-width: 1600px !important;
    }
}

</style>